export default __webpack_public_path__ + "static/media/2076_01.ffbc59d9.jpg";